import React from 'react'
import clsx from 'clsx'

interface FilterChipProps {
  label: string
  active?: boolean
  onClick: () => void
  className?: string
}

export default function FilterChip({ label, active = false, onClick, className }: FilterChipProps) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'inline-flex items-center px-4 py-1.5 rounded-full text-xs font-semibold transition-all duration-200',
        active
          ? 'bg-primary text-white'
          : 'bg-white text-text-secondary border border-gray-200 hover:border-primary hover:text-primary',
        className
      )}
    >
      {label}
    </button>
  )
}
